<template>
  <div v-if="superAdmin || userRole == 'admin'">
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs4 px-2>
          <v-card class="elevation-24">
            <v-card-title class="headline white--text primary">
							Current Settings
						</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="reload()">Reload</v-btn>
              <v-btn color="primary" @click="syncWarehouses()">Sync Warehouses</v-btn>
              <v-btn color="primary" @click="$router.push('/shipping-companies-cities')">import cities</v-btn>
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs12 v-for="(country, c) in settings" :key="'country-'+c" class="elevation-1 my-1 pa-2">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-icon size="15">public</v-icon>
                      {{country.name}} | {{country.alpha2Code}}
                    </v-flex>
                    <v-flex xs12 v-for="(wh, w) in country.warehouses" :key="'wh-'+w">
                      <v-layout row wrap>
                        <v-flex xs12 pl-2>
                          <v-icon size="15">domain</v-icon>
                          {{wh.name}}
                          <div>
                            <v-text-field
                              label="Priority"
                              dense
                              hide-details
                              v-model.trim="wh.priority"
                            >
                              <template slot="append">
                                <v-btn small flat height="dense" color="success" @click="updateWarehousePriority(wh)">update</v-btn>
                              </template>
                            </v-text-field>
                          </div>
                        </v-flex>
                        <v-flex xs12 v-for="(company, c) in wh.companies" :key="'cc-'+c">
                          <v-layout row wrap>
                            <v-flex xs12 pl-4>
                              <v-chip label outline style="color:#000;">
                                <v-icon size="15">store</v-icon>
                                {{company.name}} ({{company.daily_count}}/{{company.limit}})
                              </v-chip>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="primary" :disabled="!selectedWarehouse" @click="exportWarehouseh()">Export warehouse</v-btn> -->
            </v-card-actions>
            
          </v-card>
        </v-flex>
        <v-flex xs8 px-2>
          <v-layout wrap row justify-start pa-0>
            <v-flex xs12 px-0>
              <v-card class="elevation-24">
                <v-card-title class="headline white--text primary">
                  Add / Update Shipping Company
                  <v-spacer></v-spacer>
                  <v-autocomplete
                    :items="shippingCompanies"
                    solo
                    :loading="loading"
                    return-object
                    hide-details
                    @change="setCompany()"
                    v-model="selectedshippingCompany"
                    label="Select company to edit"
                    item-text="name"
                  ></v-autocomplete>
                </v-card-title>
                
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6 pa-1>
                      <v-text-field
                        label="Name"
                        solo
                        hide-details
                        v-model.trim="scResource.name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-autocomplete
                        :items="databaseWarehouses"
                        solo
                        multiple
                        :loading="loading"
                        item-value="id"
                        hide-details
                        v-model="scResource.warehouses"
                        label="Warehouse"
                        item-text="name"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-select
                          :items="['en', 'ar']"
                          solo
                          :disabled="loading"
                          :loading="loading"
                          hide-details
                          v-model="scResource.language"
                          label="Language"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-text-field
                        label="Daily Limit of Orders"
                        solo
                        @keypress="isNumber($event)"
                        hide-details
                        v-model.trim="scResource.limit"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-text-field
                        label="Sheet Name"
                        solo
                        hide-details
                        v-model.trim="scResource.sheet_name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-text-field
                        label="Company priority"
                        solo
                        hide-details
                        v-model.trim="scResource.priority"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-switch label="Generate Document Number"
                          hide-details
                      v-model="scResource.generate_document_number"></v-switch>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-switch label="Remove Country Code On Number"
                          hide-details
                      v-model="scResource.should_remove_country_code"></v-switch>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-textarea
                        label="Company SKUs"
                        solo
                        hide-details
                        v-model.trim="scResource.skus"
                      ></v-textarea>
                    </v-flex>
                    
                    <v-flex xs12 pa-1 py-2 style="text-align:left;font-size:18px;font-weight:600;">
                      Export Fields Match:
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-layout row wrap>
                        <draggable v-model="scResource.fields" style="width:100%">
                          <v-flex xs12 pa-1 v-for="(field, f) in scResource.fields" :key="'field-'+f" class="elevation-1 mb-1 pa-1">
                            <v-layout row wrap align-center>
                                <v-flex xs1 px-1 style="cursor: grab;">
                                  <v-icon>drag_handle</v-icon>
                                </v-flex>
                                <v-flex xs2 pa-1>
                                  <v-switch label="Constant"
                                    hide-details class="mt-0"
                                    v-model="field.is_constant"></v-switch>
                                </v-flex>
                                <v-flex xs3 pa-1>
                                  <v-text-field
                                    label="Name"
                                    solo
                                    hide-details
                                    v-model.trim="field.field_name"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs3 pa-1 v-if="field.is_constant">
                                  <v-text-field
                                    label="Define Constant"
                                    solo
                                    hide-details
                                    v-model.trim="field.field_value"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs3 pa-1 v-if="!field.is_constant">
                                  <v-select
                                    :items="fields"
                                    solo
                                    multiple
                                    :disabled="loading"
                                    :loading="loading"
                                    hide-details
                                    v-model="field.types"
                                    label="Order Key"
                                    item-value="id"
                                    item-text="name"
                                  ></v-select>
                                </v-flex>
                                <v-flex xs2 pa-1>
                                  <v-btn color="error" @click="scResource.fields.splice(f, 1)">Rmv Field</v-btn>
                                </v-flex>
                            </v-layout>
                          </v-flex>
                        </draggable>
                        <v-flex xs12 pa-1>
                          <v-btn color="success" @click="scResource.fields.push({})">Add Field</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      {{errors}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="updateSaveShippingCompany()">{{scResource.id ? 'Update' : 'Add'}} Shipping Company</v-btn>
                </v-card-actions>
                
              </v-card>
            </v-flex>
            <v-flex xs12 px-0 pt-2 v-if="false">
              <v-card class="elevation-24">
                <v-card-title class="headline white--text primary">
                  Reserve Order
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap align-center>
                    <v-text-field
                      label="Lead Key"
                      solo
                      hide-details
                      v-model.trim="key"
                    ></v-text-field>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="reserveOrder()">Reserve Order</v-btn>
                </v-card-actions>
                
              </v-card>
            </v-flex>
            <v-flex xs12 px-0 pt-2>
              <v-card class="elevation-24">
                <v-card-title class="headline white--text primary">
                  Backend Reserve Orders
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap align-center>
                    <v-textarea
                      label="Keys"
                      solo
                      hide-details
                      v-model.trim="keys"
                    ></v-textarea>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="backendBulkReservation()">Reserve Orders</v-btn>
                </v-card-actions>
                <v-card-text>
                  <div v-for="(result, r) in backendResults" :key="'result-'+r">
                    <span v-if="result.data">{{result.data.key}} | </span>
                    <span v-if="result.message">{{result.message}}</span>
                  </div>
                </v-card-text>
                
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import draggable from 'vuedraggable'
import axios from 'axios';
import { productApiUrl, crmApiUrl } from '@/config/urls';
const apiBase = productApiUrl();
export default {
  components: {
    draggable
  },
  data(){
    return {
			loading: false,
      countries:[],
      warehouses:[],
      settings:[],
      fields:[],
      selectedWarehouse:null,
      databaseWarehouses:[],
      shippingCompanies:[],
      scResource:{fields:[]},
      errors:null,
      selectedshippingCompany:null,
      key:'-NvRhZe88DIHk-SHF8ou',
      keys:'-NvRhZe88DIHk-SHF8ou',
      show_priority:{},
      backendResults:[],
    }
  },
  methods: {
    async reload() {
      this.init()
    },
    setCompany(){
      if(!this.selectedshippingCompany.fields) {
        this.selectedshippingCompany.fields = []
      }
      console.log(this.selectedshippingCompany)
      this.scResource = this.selectedshippingCompany
    },
    setErrors(arr) {
      console.log(arr)
      this.errors = arr 
      setTimeout(()=>{
        this.errors = null
      }, 5000)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getSettings(){
      this.loading = true
      const settings = await axios.get(`${apiBase}/reservation/settings`).then(x=>x.data)
      this.settings = settings
      this.loading = false
    },
    async getDropDownsData(){
      this.loading = true
      this.fields = await axios.get(`${apiBase}/reservation/order-fields`).then(x=>x.data)
      this.databaseWarehouses = await axios.get(`${apiBase}/reservation/warehouses`).then(x=>x.data)
      this.shippingCompanies = await axios.get(`${apiBase}/reservation/shipping-companies`).then(x=>x.data)
      this.loading = false
    },
    async getWarehouses(){
      return new Promise(async (res, rej) => {
        this.loading = true
        this.countries = [
          "KSA",
          "Saudi Arabia",
          "SA",
          "Bahrain",
          "BH",
          "Palestine",
          "Kuwait",
          "KW",
          "Libya",
          "LY",
          "JO",
          "Jordan",
          "UAE",
          "AE",
          "United Arab Emirates",
          "OM",
          "Oman",
          "Iraq",
          "IQ",
          "PS",
          "Qatar",
          "Lebanon",
          "Senegal",
          "QA",
          "LB",
          "SN",
          "MR",
          "Côte d'Ivoire",
          "CI",
          "Mauritania",
          "MA",
          "Morocco",
          "EG",
          "Egypt",
          "YE",
          "Yeman",
          "YE",
          "Yeman",
          "CN",
          "China",
        ].map(x=>x.toUpperCase())
        const whs = await store.collection('warehouses')
        .get()
        .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id, text:`${y.data().name} ${y.data().country}`}}))
        this.warehouses = whs
        console.log(this.warehouses)
        this.loading = false
        res()
      })
    },
    async syncWarehouses() {
      this.loading = true
      const result = await axios.post(`${apiBase}/reservation/sync-warehouses`, [...this.warehouses.map(w=>({name:w.name, country:w.country, lock:w.lock?true:false}))]).then(x=>x.data)
      console.log(result)
      this.loading = false
    },
    async updateSaveShippingCompany() {
      this.loading = true
      const result = await axios.post(`${apiBase}/reservation/shipping-company`, {...this.scResource}).then(x=>x.data).catch(error => {
        if (error) {
          this.$emit('snackbarNotification', `${error.message}`, 'error')
          this.setErrors(error)
        }
      });
      if(result.status) {
        this.scResource = {fields:[]}
        this.selectedshippingCompany = null
        this.init()
      }
      this.loading = false
    },
    async updateWarehousePriority(wh) {
      this.loading = true
      const result = await axios.post(`${apiBase}/reservation/update-warehouse`, {...wh}).then(x=>x.data).catch(error => {
        if (error) {
          this.$emit('snackbarNotification', `${error.message}`, 'error')
          this.setErrors(error)
        }
      });

      if(result.status) {
        this.scResource = {fields:[]}
        this.selectedshippingCompany = null
        this.init()
      }
      this.loading = false
      
    },
    async init(){
      await this.getSettings()
      await this.getWarehouses()
      await this.getDropDownsData()
    },
    backendReservation(key) {
      return new Promise(async (res, rej)=>{
        console.log(key)
        try {
          const result = await axios.get(productApiUrl(`start-reservation/${key}?crm=true`)).then(x=>x.data)
          this.backendResults.push(result)
          
        } catch (error) {
          this.backendResults.push('error')
        }
        res(true)
      })
    },
    async backendBulkReservation() {
      const keys = this.keys.split('\n')
      console.log(keys)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        try {
          await this.backendReservation(key)
        } catch (error) {
          console.log(error)
        }
      }
    },
    
    async getLead(key) {
      const lead = await store.collection('leads').doc(key).get().then(x=>x.data())
      return lead
    },
    getOrderItems(lead) {
      const orderItems = lead.order.map(x=>({sku:x.sku, quantity:x.quantity}))
      return orderItems
    },
    async fetchProductBySku(sku) { 
      return new Promise(async (res, rej)=>{
        const snapshot = await store.collection("products")
        .where("sku", "==", sku)
        .get();
        const result = snapshot.docs.map(doc => {
            const data = doc.data();
            const warehouses = data.warehouses || [];
            return {
                ...data,
                warehouses,
                key: doc.id
            };
        });
        const livesnapshot = await store.collection("productsLive")
        .where("sku", "==", sku)
        .get();
        const livesnapshotresult = livesnapshot.docs.map(doc => {
            const data = doc.data();
            const alt_warehouse = data.warehouses.find(x=>x.warehouse ==='Standard Alternative')
            return {
                sku:data.sku,
                alt_warehouse,
                key: doc.id
            };
        });
        console.log('livesnapshotresult', livesnapshotresult)
        if(result.length && livesnapshotresult.length) {
          const alt_warehouse = livesnapshotresult[0].alt_warehouse
          const product = result[0]
          product.alternatives =  alt_warehouse && alt_warehouse.alternatives && alt_warehouse.alternatives.length ? alt_warehouse.alternatives : false
          return res(product)
        } else {
          return res(false)
        }
      })
    },
    async fetchOrderItemsProducts(items) {
      console.log('fetchOrderItemsProducts')
      const match_products = items.map(x=>x.sku).map(sku=>this.fetchProductBySku(sku))
      const products = await Promise.all(match_products)
      return products.filter(x=>x)
    },
    async fetchStoreWarehouses(country) {
      console.log('fetchStoreWarehouses')
      let search_country = country.toUpperCase()
      if(country ==='Saudi Arabia') {
        search_country = 'KSA'
      }
      if(country ==='Palestine') {
        search_country = 'Palestine'
      }
      if(country === 'United Arab Emirates') {
        search_country = 'United Arab Emirates'
      }
      const warehouses = await store.collection('warehouses')
        .where('country', '==', search_country)
        .get()
        .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id, text:`${y.data().name} ${y.data().country}`}}))
	    console.log('search_country', search_country, warehouses)
      return warehouses.filter(x=>!x.lock)
    },
    async fetchSettings(lead) {
      const data = await axios.get(`${apiBase}/reservation/settings/${lead.country_id?lead.country_id:lead.country}`).then(x=>x.data)
      console.log('fetchSettings', lead.cc, data)
      const settings  = {...data, warehouses:data.warehouses.filter(w=>!w.lock)}
      return settings
    },
    filterProductWarehouses(products, countryWarehouses){
      console.log('filterProductWarehouses', products)
      const filterMap = countryWarehouses.filter(x=>!x.lock).map(y=>y.name)
      return products
        .map(x=>({
          ...x, 
          warehouses: x.warehouses
          .filter(y=>filterMap.includes(y.warehouse))
          .map(x=>({...x, wh_object:countryWarehouses.find(y=>y.name === x.warehouse)}))
          .sort((a, b)=> a.wh_object.priority - b.wh_object.priority)
        }))
    },
    checkAvailableQuantity(orderItemsWarehouses){
      console.log('checkAvailableQuantity')
      return orderItemsWarehouses.map(x=>x.available).filter(x=>x).length === orderItemsWarehouses.length
    },
    async getAlternatives(item_product, item, storeCountryWarehouses, warehouse) {
      if(!item_product.alternatives) {
        return false;
      }
      const getAlternatives = item_product.alternatives.sort((a, b)=> a.priority - b.priority).map(x=> this.fetchProductBySku(x.sku))
      const alternatives = await Promise.all(getAlternatives)
      const alternatives_filtered_warehosues = this.filterProductWarehouses(alternatives, storeCountryWarehouses)
      const filtered_alternatives = alternatives_filtered_warehosues.filter(alt_product=> this.checkIfItemAvailable(alt_product, item, warehouse))
      if(filtered_alternatives.length) {
        return filtered_alternatives[0]
      } else {
        return false;
      }
    },
    checkIfItemAvailable(item_product, item, warehouse) {
      return item_product && item_product.warehouses.filter(wh=>wh.warehouse === warehouse.name).find(x=>(x.quantity-(x.reserved?Math.abs(x.reserved):0)) >= item.quantity) ? true : false
    },
    async getOrderItemsWarehouses(productWithFilteredWarehouses, orderItems, storeCountryWarehouses) {
      return new Promise(async(res, rej)=>{
        console.log('getOrderItemsWarehouses')
        const available_warehouses = storeCountryWarehouses;
        for (let k = 0; k < available_warehouses.length; k++) {
          const warehouse = available_warehouses[k];
          const items = []
          for (let i = 0; i < orderItems.length; i++) {
            const item = orderItems[i];
            const item_product = productWithFilteredWarehouses.find(x=>x.sku === item.sku)
            let active_item = {...item}
            active_item.product_key = item_product.key
            active_item.item_name = item_product.item_name
            active_item.available = this.checkIfItemAvailable(item_product, item, warehouse)
            console.log('active_item.available', active_item.available)
            if(active_item.available) {
              active_item.reservation_warehouse = item_product ? item_product.warehouses.filter(wh=>wh.warehouse === warehouse.name).find(x=>x.quantity >= item.quantity) : false
            } else {
              console.log('Getting Alternative')
              const alternative = await this.getAlternatives(item_product, item, storeCountryWarehouses, warehouse)
              if(alternative) {
                active_item = {}
                active_item.product_key = alternative.key
                active_item.item_name = alternative.item_name
                active_item.sku = alternative.sku
                active_item.quantity = item.quantity
                active_item.reservation_warehouse = alternative ? alternative.warehouses.filter(wh=>wh.warehouse === warehouse.name).find(x=>x.quantity >= item.quantity) : false
                active_item.available = true
                active_item.alternative = true
                active_item.original_sku = item.sku
              }
            }
            items.push({...active_item})
          }
          if(items.filter(x=>x.available).length === orderItems.length) {
            return res(items)
          }
        }
        return res(false)
      })
    },
    filterCompaniesByCity(companies, lead){
      const lead_city_name = lead.city
      return companies.filter(company=> company.cities.map(x=>x.original.name).includes(lead_city_name))
    },
    filterCompaniesBySKUs(companies, lead){
      const lead_skus = lead.order.map(x=>x.sku)
      const parsedCompaniesSkus = companies
      .filter(x=>x.skus)
      .map(x=>({...x, parsed_skus:x.skus.split(',').map(sku=>sku.trim())}))
      const check_specific = parsedCompaniesSkus.filter(company => company.parsed_skus.some(sku=>lead_skus.includes(sku)))
      if(check_specific.length) {
        return check_specific
      } else {
        return companies
      }
    },
    
    getShippingCompany(settings, orderItemsWarehouses, lead) {
      console.log('getShippingCompany')
      const warehouses = settings.warehouses
      if(!warehouses.length) return this.errorResponse('No settings warehouses', {key:lead.key}, lead)
	    if(orderItemsWarehouses.filter(x=> !x.reservation_warehouse || !x.reservation_warehouse.warehouse).length)  return this.errorResponse('OrderItem has no warehouse', {key:lead.key}, lead)

      const orderItemsWarehouse = [...new Set(orderItemsWarehouses.map(x => x.reservation_warehouse.warehouse))];
      if(orderItemsWarehouse.length>1) return this.errorResponse('Order with multiple warehouses', {key:lead.key}, lead)
      const selectedItemWarehouse = orderItemsWarehouse[0]
      const firstWarehouse = warehouses.length && warehouses.find(w=>w.name === selectedItemWarehouse) 
      if(!firstWarehouse) return this.errorResponse('No warehouse', {key:lead.key}, lead)
      const companies = firstWarehouse.companies
      if(!firstWarehouse.companies.length) return this.errorResponse('Warehouse has no companies', {key:lead.key}, lead)
      console.log('firstWarehouse.companies', companies)
      const filteredCompaniesForCities = this.filterCompaniesByCity(companies, lead)
      if(!filteredCompaniesForCities || !filteredCompaniesForCities.length) return this.errorResponse('filteredCompaniesForCities has no companies', {key:lead.key}, lead)
      const filteredCompaniesForSkus = this.filterCompaniesBySKUs(filteredCompaniesForCities, lead)
      if(!filteredCompaniesForSkus || !filteredCompaniesForSkus.length) return this.errorResponse('filteredCompaniesForSkus has no companies', {key:lead.key}, lead)
      const sortedCompanies = filteredCompaniesForSkus.sort((a, b)=> a.priority - b.priority)
      console.log('sortedCompanies', sortedCompanies)
      if (sortedCompanies.length > 1 && sortedCompanies[0].priority === sortedCompanies[1].priority) {
        const samePriorityCompanies = sortedCompanies.filter(company => company.priority === sortedCompanies[0].priority);
        const sortedSamePriorityCompanies = samePriorityCompanies.sort((a, b) => a.daily_count - b.daily_count);
        console.log('finalSortedCompanies', sortedSamePriorityCompanies);
        const firstShippingCompany = sortedSamePriorityCompanies[0];
        return firstShippingCompany;
      }
      const firstShippingCompany = sortedCompanies[0]
      return firstShippingCompany
    },
    async addRecordToLog(item, orderItemsWarehouse, lead){
      console.log('addRecordToLog')
      const log = {
        product_sku:item.sku,
        product_key:orderItemsWarehouse.product_key, //
        user:'system',
        date:getCDate(),
        status:'reserved',
        transaction_timestamp: new Date().getTime(),
        transaction_id: randomString(8, '#Aa'),
        status_date:getCDate(),
        timestamp:new Date(getCDate()).getTime(),
        quantity:parseInt(item.quantity),
        transaction:'add',
        warehouse_name:orderItemsWarehouse.reservation_warehouse.warehouse,
        warehouseh_key:orderItemsWarehouse.reservation_warehouse.wh_object.key,
        order_key:lead.key,
        document_number: lead.document_number ? lead.document_number : 0
      }
		  await insertToSheet(null, log, 'reservation_transactions')
      await store.collection('reservation_transactions').add(log)
    },
    recordReservedTransaction(item) {
      return new Promise(async (res, rej)=>{
        console.log('recordReservedTransaction')
        var productDocumentRef = store.collection("products").doc(item.product_key);
        await store.runTransaction(function(transaction) {
          return transaction.get(productDocumentRef).then(async function(productDocument) {
            if (!productDocument.exists) {
                res(false);
            }
            const product = productDocument.data()
            const productWarehouse = product.warehouses.find(x=>x.warehouse == item.reservation_warehouse.warehouse)
            const reserved = productWarehouse.reserved ? parseInt(productWarehouse.reserved) : 0
            productWarehouse.reserved = reserved + parseInt(item.quantity);

            await insertToSheet(null, {
              product_key:item.product_key,
              warehouse:item.reservation_warehouse.warehouse,
              quantity:item.quantity,
              before:reserved,
              after:productWarehouse.reserved
            }, 'warehouse_log')
            
            transaction.update(productDocumentRef, product);
          });
        })
        return res()
      })
    },
    async confirmReservation(orderItemsWarehouses, lead) {
      return new Promise(async (res, rej)=>{
        console.log('confirmReservation')
        for (let i = 0; i < lead.order.length; i++) {
          const item = lead.order[i];
          const orderItemsWarehouse = orderItemsWarehouses.find(x=>x.sku === item.sku)
          await this.recordReservedTransaction(orderItemsWarehouse)
          await this.addRecordToLog(item, orderItemsWarehouse, lead)
        }
        res(orderItemsWarehouses)
      })
    },
    getExportCity(shippingCompany, city) {
      return shippingCompany.cities && shippingCompany.cities.length ? shippingCompany.cities.find(x=>x.original.name === city).city_name :  city
    },
    getBasePhone(lead, phone_type) {
      if(lead.country_id === 68) {
        return lead[phone_type]? lead[phone_type].slice(2) : lead[phone_type]
      } else {
        return lead[phone_type] ? lead[phone_type].slice(3) : lead[phone_type]
      }
    },
    async getProductArName(sku) {
      return new Promise(async(res, rej)=>{
        const name = await axios.get(`${apiBase}/reservation/product-ar-name/${sku}`).then(x=>x.data)
        res(name)
      })
    },
    getFieldValue(field, lead, item, shippingCompany, reservation, item_ar_name){
      const leadFields = ["key", "manual_total","document_number", "address","phone_number_1","phone_number_2","name","business_name", "note"]
      const itemFields = ["item_name","item_quantity","item_sku", "order_items_quantity"]
      const specialField = ["en_city", "city", "warehouse"]
      const phoneNumbers = ["phone_number_1","phone_number_2"]
      if(field.is_constant) {
          return field.field_value
      } else {
        let value = ``;
        field.types.forEach(type=>{
          if(leadFields.includes(type.name)) {
            if(shippingCompany.should_remove_country_code) {
              if(phoneNumbers.includes(type.name)) {
                value += this.getBasePhone(lead, type.name)
              } else {
                value += lead[type.name] + ' '
              }
            } else {
              value += lead[type.name] + ' '
            }
            
          }
          if(itemFields.includes(type.name)) {
            if(type.name === "item_name") {
              value += item_ar_name + ' '
            } else if(type.name === "item_quantity") {
              value += item.quantity + ' '
            } else if(type.name === "item_sku") {
              value += item.sku + ' '
            } else if (type.name === "order_items_quantity") {
              value += lead.order.reduce((a, b)=>a+b.quantity, 0) + ' '
            }
          }
          if(specialField.includes(type.name)) {
            if(type.name === 'warehouse') {
              value += reservation[0].reservation_warehouse.warehouse
            } else {
              value += lead['export_city']
            }
          }
        })
        return value
      }
    },
    async getExportLead(reservation, shippingCompany, lead){
      return new Promise(async (res, rej)=>{
        console.log('getExportLead---->', reservation)
        const companyFields = shippingCompany.fields
        lead.export_city = this.getExportCity(shippingCompany, lead.city)
        const exportItem = {}
        const exportItemArray = []
        for (let i = 0; i < lead.order.length; i++) {
          const item = lead.order[i];
          const itemExport = [];
          const item_ar_name = await this.getProductArName(item.sku)
          companyFields.forEach((field, i)=>{
            const value = this.getFieldValue(field, lead, item, shippingCompany, reservation, item_ar_name)
            exportItem[field.field_name] = value
            itemExport.push(value)
          })
          exportItemArray.push(itemExport)
        }
        return res({
          exportItem,
          exportItemArray,
        })
      })
    },
    async addStatusToTimeline(lead, status){
      return new Promise(async (res, rej)=>{
        let bb = await db.ref('uKeys').push()
        if (!lead.update_timeline) lead.update_timeline = {}
        lead.update_timeline[bb.key] = {
          status: status,
          agent: 'System Backend',
          date: getCDate()
        }
        if (!lead.status_timeline) {
          lead.status_timeline = {}
        }
        if (!lead.status_timeline[status]) {
          lead.status_timeline[status] = {}
        }
        lead.status_timeline[status]['date'] = getCDate()
        lead.status_timeline[status]['agent'] = 'System Backend'
        // store.collection('leads').doc(x.key).update(x)
        await db.ref('uKeys').update({
          [bb.key]: null
        })
        res(lead)
      })
    },
    async updateNinjaLead(lead) {
      return new Promise(async(res, rej)=>{
        if(lead.ninja) {
          let pu = await axios.post(crmApiUrl('crmleads'), lead).then(x=>x.data)
          return res(pu)
        } else {
          return res(true)
        }
      })
    },
    async updateLead(lead, reservation, shippingCompany) {
      return new Promise(async (res, rej)=>{
        const status = 'Dispatch'
        let status_slug = status.split(' ').join('_').toLowerCase()
        console.log('updateLead', reservation)
        lead.reservation = reservation
        lead.reserved = true
        lead.reserved_wh = true
        lead.warehouse = reservation[0].reservation_warehouse
        lead.customer_id  = shippingCompany.name
        lead.order_status = status
        lead  = await this.addStatusToTimeline(lead, status_slug)
        const update = await store.collection('leads').doc(lead.key).update(lead)
        await this.updateNinjaLead(lead)
        return res(update)
      })
    },
    async checkSheetExists(sheet_name) {
      return new Promise(async (res, rej)=>{
        const sheet = await axios.get(`${apiBase}/sheets/get/${sheet_name}`).then(x=>x.data)
        if(!sheet.data) {
          return res(false)
        }
        if(sheet.data && !Array.isArray(sheet.data) && sheet.data.error) {
          return res(false)
        }
        return res(true)
      })
    },
    async insertToSheet(shippingCompany, lead, sheet = null) {
      console.log('insertToSheet')
      return await axios.post(`${apiBase}/sheets/insert/${sheet ? sheet : shippingCompany.sheet_name}`, Object.values(lead).filter(x=>typeof x !== 'object')).then(x=>x.data)
    },
    async insertToAllSheet(shippingCompany, exportsToSheet) {
      return new Promise(async(res, rej)=>{
        const result = []
        for (let i = 0; i < exportsToSheet.length; i++) {
          const data = exportsToSheet[i];
          const status = await this.insertToSheet(shippingCompany, data)
          result.push(status)
        }
        res(result)
      })
    },
    async reportFiledOutOfStock(lead, type, message = 'Need Check'){
      return new Promise(async (res, rej)=>{
        const data = {
          key:lead.key,
          country:lead.country,
			    shipping_status:lead.shipping_status,
          type,
          message:message
        }
        await this.insertToSheet(null, data, type)
        res(true)
	    })
    },
    updateLeadItems(lead, orderItemsWarehouses) {
      const alternatives = orderItemsWarehouses.filter(x => x.alternative);
      if (!alternatives.length) {
        return lead.order; 
      }

      return lead.order.map(item => {
        const matchingAlternative = alternatives.find(alt => alt.original_sku === item.sku);
        return matchingAlternative ? { ...item, sku: matchingAlternative.sku, product: matchingAlternative.item_name, product_key: matchingAlternative.product_key } : item;
      });
    },
    errorResponse(message, obj = {}, lead = {}, type = 'failed_need_check_orders'){
      this.reportFiledOutOfStock(lead, type, message)
      console.log({
        status: false,
        type,
        message,
        data:{...obj}
      })
      return {
        status: false,
        type,
        message,
        data:{...obj}
      }
    },
    arabic(string){
      var arabic = /[\u0600-\u06FF]/;
      var pattern = /[\u0600-\u06FF\u0750-\u077F]/;
      let result = pattern.test(string);
      return arabic.test(string) && result
    },
    checkCancelReservation(lead) {
      const {shipping_status, order_status} = lead
      const allowed_order_statuses = ["Confirmed", "Dispatch"]
      const allowed_shipping_statuses = [
        "pending",
        "Out of stock",
        "Reschedule",
        "unpacked",
      ]
      if (!allowed_order_statuses.includes(order_status)) {
        return true
      }
      if (lead.shipping_status && !allowed_shipping_statuses.includes(shipping_status)) {
        return true
      }
      return false
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    getNewDocNum() {
      return new Promise(async (res, rej) =>{
        await db.ref(`settings/barcode`)
          .transaction(function (current_value) {
            return (current_value || 0) + 1;
          });
        let n = await db.ref(`settings/barcode`).once('value').then(x => x.val())
        let barcode = `B${this.pad(n, 8)}`
        res(barcode)
      })
    },
    async recordShippingCompanyOrder(shippingCompany){
      return new Promise(async (res, rej)=>{
        const update = axios.post(`${apiBase}/reservation/shipping-count`, {
          company_id: shippingCompany.id,
          count:1
        }).then(x=>x.data)
        res(update)
      })
    },
    async reserveOrder(){
      const lead = await this.getLead(this.key)
      // lead.order[0].sku = 'A.000541.XXXL'
      if(!lead) {
        return this.errorResponse('Lead Not Found', {key:this.key}, {key:this.key});
      }
      console.log('lead', lead)
      const cancel_reservation = this.checkCancelReservation(lead)
      if(cancel_reservation) {
        return this.errorResponse('Not eligabile for reservation', {key:this.key}, lead);
      }
      if(lead.reserved) {
        return this.errorResponse('Already Reserved', {key:this.key}, lead);
      }
      if(!lead.name) {
        return this.errorResponse('Lead has no name', {key:this.key}, lead);
      }
      if(!lead.address) {
        return this.errorResponse('Lead has no address', {key:this.key}, lead);
      }
      if(lead.address.length < 30) {
        return this.errorResponse('Lead address too short', {key:this.key}, lead);
      }
      if(!lead.order || !lead.order.length) {
        return this.errorResponse('Has no Items', {key:this.key}, lead);
      }
      const orderItems = this.getOrderItems(lead)
      console.log('orderItems', orderItems)
      const storeProducts = await this.fetchOrderItemsProducts(lead.order)
      console.log('storeProducts', storeProducts)
      if(orderItems.length !== storeProducts.length) {
        return this.errorResponse('Could not match all products', {storeProducts, orderItems}, lead);
      }
      const settings = await this.fetchSettings(lead)
      console.log('settings', settings)
      if(!settings) {
        return this.errorResponse('No settings defined', {lead}, lead);
      }
      const storeCountryWarehouses = await this.fetchStoreWarehouses(settings.name)
      console.log('storeCountryWarehouses', storeCountryWarehouses)
      if(!storeCountryWarehouses.length) {
        return this.errorResponse('No warehouses for country', {lead}, lead);
      }
      const productWithFilteredWarehouses = this.filterProductWarehouses(storeProducts, storeCountryWarehouses)
      console.log('productWithFilteredWarehouses', productWithFilteredWarehouses)
      if(productWithFilteredWarehouses.map(x=>x.warehouses.length).filter(x=>x>0).length !== storeProducts.length) {
        return this.errorResponse('Some products has no warehouses', {productWithFilteredWarehouses}, lead);
      }
      const orderItemsWarehouses = await this.getOrderItemsWarehouses(productWithFilteredWarehouses, orderItems, storeCountryWarehouses)
      console.log('orderItemsWarehouses', orderItemsWarehouses)
      if(!orderItemsWarehouses) {
        return this.errorResponse('Some products are not available', {orderItemsWarehouses}, lead, 'out_of_stock');
      }
      if(orderItemsWarehouses.filter(x=>x.alternative).length) {
        console.log('order with alternatives to be updated')
        const updatedOrder = this.updateLeadItems(lead, orderItemsWarehouses)
        lead.order = updatedOrder
        console.log('after alternative updates updatedOrder, lead', updatedOrder, lead)
      }
      const checkAvailablity = this.checkAvailableQuantity(orderItemsWarehouses)
      console.log('checkAvailablity', checkAvailablity)
      if(!checkAvailablity) {
        return this.errorResponse('Some products are not available', {orderItemsWarehouses}, lead, 'out_of_stock');
      }


      const shippingCompany = this.getShippingCompany(settings, orderItemsWarehouses, lead)
      console.log('shippingCompany', shippingCompany)
      if(shippingCompany && shippingCompany.message) {
        return shippingCompany; // returns error
      }
      if(shippingCompany && shippingCompany.language === 'en') {
        if (this.arabic(lead.name)) {
          return this.errorResponse('Name must be english', {shippingCompany}, lead);
        }
        if (this.arabic(lead.address)) {
          return this.errorResponse('Address must be english', {shippingCompany}, lead);
        }
      }
      
      if(shippingCompany && shippingCompany.generate_document_number && !lead.document_number) {
        lead.document_number = await this.getNewDocNum()
      }
      if(shippingCompany && !shippingCompany.sheet_name) {
        return this.errorResponse('Shipping company has no sheet', {shippingCompany}, lead);
      }
      const check_sheet = await this.checkSheetExists(shippingCompany.sheet_name)
      if(!check_sheet) {
        const error = errorResponse('Shipping company wrong sheet name', {shippingCompany}, lead);
        return res(error);
      }
      const reservation = await this.confirmReservation(orderItemsWarehouses, lead)
      console.log('reservation...', reservation)
      await this.recordShippingCompanyOrder(shippingCompany)
      const exportLead = await this.getExportLead(reservation, shippingCompany, lead);
      console.log('exportLead', exportLead)
      const exportsToSheet = exportLead.exportItemArray
      
      const insertSuccess = await this.insertToAllSheet(shippingCompany, exportsToSheet);
      console.log('insertSuccess', insertSuccess)
      const updatedLead = await this.updateLead(lead, reservation, shippingCompany);
      console.log('updatedLead', updatedLead)
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
  },
  watch:{
  },
  async created(){
    this.init()
     
    

    // let o = await db.ref('countries/171').once('value').then(x=>x.val())
    // await db.ref('countries/250').update(o)
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
